module.exports = __webpack_public_path__ + "img/barolo.544a4b72.jpg";